import React from 'react';
import PropTypes from 'prop-types';
import style from '../cssmodules/main.module.scss';

function Main({ children, flush }) {
  const classes = flush
    ? `${style.wrapper} ${style.wrapperFlush}`
    : `${style.wrapper}`;
  return <main className={classes}>{children}</main>;
}

Main.defaultProps = {
  flush: false,
};

Main.propTypes = {
  children: PropTypes.element.isRequired,
  flush: PropTypes.bool,
};

export default Main;
